import { z } from "zod/v4";

export const ShareMetricRequestBodySchema = z.object({
  id: z.uuid(),
});
export type ShareMetricRequestBodyType = z.infer<
  typeof ShareMetricRequestBodySchema
>;

export const ShareMetricResponseBodySchema = z.object({
  html: z.string(),
  png: z.string(),
});
export type ShareMetricResponseBodyType = z.infer<
  typeof ShareMetricResponseBodySchema
>;
